<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="acknow">
<p class="ct"><a class="xref" href="#/OEBPS/Text/pppstrangers005#toc">Acknowledgments</a></p>
<p class="pf">I’d like to thank everyone who reviewed <i class="calibre3">Strangers</i> in manuscript form: Michael Garmon, Erin Hinnant, Rachel Garmon, Amanda Evans, and Carl Halbirt.</p>
<p class="calibre4">I’d also like to thank these folks for their expertise on archaeology, rare documents, and the history of the St. Augustine area: Dr. Robert Connolly of Chucalissa Archaeological Museum; Carla Summers of the Matheson Center in Gainesville, Florida; Carl Halbirt, St. Augustine’s City Archaeologist (which I think is one of the coolest jobs on Earth); Melissa Dezendorf, Assistant to St. Augustine’s City Archaeologist, Forrest County, Mississippi Coroner, Butch Benedict; and Dr. Jerald Milanich of the Florida Museum of Natural History at the University of Florida. I also appreciate the assistance of the staff of St. Augustine Historical Society Research Library and the tour guides at the St. Augustine Ripley’s Believe It Or Not! Odditorium, The Fountain of Youth Archaeological Park, Casa Zorayda, Ghost Tours of St. Augustine, and Old Town Trolley Tours.</p>
<p class="calibre4">These people helped immeasurably in making <i class="calibre3">Strangers</i> as accurate as possible, but all errors are completely mine.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-strangers006.vue?22076a44